import { useTranslation } from "react-i18next";
import { adminApi } from "../../services/api";
import AdminPanel from "../../components/admin/AdminPanel";
import { AdminUnavailablePanel } from "../../components/admin/AdminUnavailable";
import useAdminData from "../../components/admin/useAdminData";
import { unwrap } from "../../components/admin/adminFormat";

/**
 * REGLE ABSOLUE : /admin/overview lit GET /api/admin/dashboard, qui ne
 * fournit aujourd'hui que des compteurs (users/declarations/matchings/
 * transactions/certificates). Si l'appel echoue, data reste null (voir
 * useAdminData) et on affiche explicitement l'indisponibilite - jamais
 * un 0 par defaut, jamais une alerte ou une tendance inventee.
 */
export default function Overview() {
  const { t } = useTranslation();
  const { data, loading } = useAdminData(async () => unwrap(await adminApi.getDashboard()), []);

  if (loading) return <AdminPanel>{t("common.loading")}</AdminPanel>;
  if (!data) return <AdminUnavailablePanel t={t} title={t("admin.api_unavailable_title")} description={t("admin.dashboard_unavailable")} />;

  const items = [
    ["users", data.users?.total],
    ["declarations", (data.declarations?.lost ?? 0) + (data.declarations?.found ?? 0)],
    ["matchings", data.matchings?.total],
    ["transactions", data.transactions?.total],
    ["certificates", data.certificates?.total],
  ];

  return (
    <>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(145px,1fr))", gap: 14 }}>
        {items.map(([key, value]) => (
          <AdminPanel key={key}>
            <div style={{ color: "#64748B" }}>{t(`admin.stats.${key}`)}</div>
            <strong style={{ fontSize: 28 }}>{value ?? "—"}</strong>
          </AdminPanel>
        ))}
      </div>
      <AdminPanel>
        <strong>{t("admin.alerts")}</strong>
        <p style={{ color: "#64748B", marginBottom: 0 }}>
          {t("admin.dashboard_summary", {
            inactive: data.users?.inactive,
            pending: data.transactions?.pending,
            rejected: data.matchings?.rejected,
          })}
        </p>
      </AdminPanel>
    </>
  );
}
